import {
  Button,
  Modal,
  Form,
  Input,
  Typography,
  message,
  Select,
  Row,
  Col,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useEffect,
  useRef
} from "react";
import {
  EditOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const AddModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [anetList, setAnetList] = useState([]);
  const [agentLoading, setAgentLoading] = useState(false);
  const [editData, setEditData] = useState(null); 
  const modalRef = useRef(null);
  const { onSuccess } = props;

  useImperativeHandle(ref, () => ({
    setModelAdd: async () => {
      setVisible(true);
      setEditData(null);
      form.resetFields();
      await getAgentTypeList();
    },
 
    setModelEdit: async (record) => {
      setVisible(true);
      setEditData(record);
      await getAgentTypeList();
      form.setFieldsValue({
        carrier: record.carrier,
        agent: record.agentVendorId,
        payee: record.payeeVendorId,
        remark: record.remark,
      });
    },
  }));

  const getAgentTypeList = async () => {
    if (anetList.length > 0 || agentLoading) return;
    setAgentLoading(true);
    try {
      const res = await http.get(api.getAgentType);
      const data = res?.data || res;
      const list = (data || []).map((item) => ({
        value: item.vendorId,
        label: item.vendorName,
      }));
      setAnetList(list);
    } catch (err) {
      message.error("Request Error");
    } finally {
      setAgentLoading(false);
    }
  };

  const onFinish = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      const { carrier, agent, payee, remark } = values;

      let params;
      let apiUrl;
      if (editData && editData.id) {
        params = {
          id: editData.id,
          agentVendorId: agent,
          payeeVendorId: payee,
          carrier: carrier,
          remark: remark || "",
        };
        apiUrl = api.getInsuranceSummaryUpdate; 
      } else {
       
        params = {
          agentVendorId: agent,
          payeeVendorId: payee,
          carrier: carrier,
          remark: remark || "",
        };
        apiUrl = api.getInsuranceSummaryAdd;
      }

      const res = await http.post(apiUrl, params);

      if (res?.code === "1") {
        message.success(editData ? "Insurance updated successfully." : "Insurance created successfully.");
        setVisible(false);
        form.resetFields();
        setEditData(null);
        onSuccess && onSuccess();
      } else {
        message.error(res?.msg);
      }
    } catch (err) {
      console.error(err);
      if (!err?.errorFields) {
        message.error("Request failed, please try again");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
    setEditData(null); 
  };

  return (

    <Modal
      ref={modalRef}
      title={
        <Row justify="start" align="middle" className="model_title">
          <Col>
            <EditOutlined className="model_title_mr10" />
          </Col>
          <Col>
            <Typography.Title level={4} className="mg">
              {editData ? "EDIT INSURANCE" : "NEW INSURANCE"}
            </Typography.Title>
          </Col>
        </Row>
      }
      width="1000px"
      open={visible}
      onCancel={handleCancel}
      maskClosable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" loading={loading} onClick={() => form.submit()}>
            Submit
          </Button>
        </div>
      }
      styles={{
        body: {
          overflow: 'visible',
        }
      }}
    >
      <div className="model_top" style={{ width: "100%" }}>
         <div  className="model_content">
        <Form
          form={form}
          name="createInsuranceForm"
          layout="horizontal"
          style={{ width: "100%", marginTop: "10px" }}
          onFinish={onFinish}
        >
          
          <Form.Item
            name="carrier"
            label="Carrier"
            rules={[{ required: true, message: "Please input Carrier" }]}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
          >
            <Input placeholder="Carrier" />
          </Form.Item>

          <Form.Item
            name="agent"
            label="Agent"
            rules={[{ required: true, message: "Please select Agent" }]}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
          >
            <Select
              className="agent-inline-item"
              style={{ width: "100%" }}
              popupMatchSelectWidth={false}
          
              listHeight={200}
              placeholder="Please select Agent"
              options={anetList}
              loading={agentLoading}
              showSearch
              optionFilterProp="label"
              onDropdownVisibleChange={(open) => open && getAgentTypeList()}
            />
          </Form.Item>

          <Form.Item
            name="payee"
            label="Payee"
            rules={[{ required: true, message: "Please select Payee" }]}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
          >
            <Select
              className="agent-inline-item"
              style={{ width: "100%" }}
              popupMatchSelectWidth={false}
            
              listHeight={200}
              placeholder="Please select Payee"
              options={anetList}
              loading={agentLoading}
              showSearch
              optionFilterProp="label"
              onDropdownVisibleChange={(open) => open && getAgentTypeList()}
            />
          </Form.Item>

          <Form.Item name="remark" label="Remark" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
            <Input placeholder="Remark" />
          </Form.Item>
        </Form>
        </div>
      </div>
    </Modal>
  );
});

export default AddModal;